import { render, staticRenderFns } from "./VFullScreenPopup.vue?vue&type=template&id=3c4227e4&scoped=true"
import script from "./VFullScreenPopup.vue?vue&type=script&lang=js"
export * from "./VFullScreenPopup.vue?vue&type=script&lang=js"
import style0 from "./VFullScreenPopup.vue?vue&type=style&index=0&id=3c4227e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4227e4",
  null
  
)

export default component.exports